import React from 'react';
import ValuationPane from "./valuation";

export default function ValuationPage({writable}) {

    return(
            <ValuationPane writable={writable}/>
    )

}